import React from 'react';

const CustomStepper = ({ steps, heading, onStepSelect, currentStepGroup, currentStep, selectedType }) => {
  
  return (
    <div className="w-full max-w-lg mx-auto text-center">
      
      <div className='text-2xl mb-8'>{heading || ""}</div>
      <div className="grid md:grid-cols-3 gap-4">
        {steps.map((step, index) => (
          <button
            key={index}
            className={`text-lg font-semibold py-4 px-6 border rounded shadow-md border-secondary ${((currentStepGroup===1 && index === currentStep) || (currentStepGroup===2 && index+1 === selectedType.id)) ? 'bg-secondary text-black' : ''}`}
            onClick={() => {
              onStepSelect(index, step);
            }}
          >
            {step.name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CustomStepper;